import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VideoProviderService {
  public list = [
    { id: 1, label: "Other", value: 0 },
    { id: 2, label: "YouTube", value: 1 },
    { id: 3, label: "Vimeo", value: 2 },
    { id: 3, label: "Facebook", value: 3 },
  ];

  constructor() { }
}
